import PropTypes from 'prop-types';
import React from 'react';

import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleMedia = ({
    image,
    credit,
    borderBottom,
    borderTop,
    isInModal
}) => {

    return (
        <div className={`${isInModal ? '' : 'layout-container-padding-right'} z-10 relative flex flex-wrap max-w-container bg-white ${borderBottom ? 'editorial-white-border-b' : ''} ${borderTop ? 'editorial-white-border-t' : 'editorial-white-spacing-t'}`}>
            {/* Left Sidebar */}
            <div className='w-sidebar'>
                <div className='flex flex-col items-center'>
                </div>
            </div>
            {/* Image */}
            <div className='flex-1 layout-negative-margin'>
                <section className={`${isInModal ? '' : 'sm:w-6/12'} layout-item-padding`}>
                    <Image
                        containerClassName='rounded-lg'
                        {...image} />

                    {credit &&
                        <p className='pt-20 type-style-7 md:w-10/12'>
                            {credit}
                        </p>
                    }
                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    borderBottom: PropTypes.bool,
    borderTop: PropTypes.bool,
    credit: PropTypes.string,
    image: PropTypes.object,
    isInModal: PropTypes.bool,
};


ModuleMedia.propTypes = propTypes;

export default ModuleMedia;
